const environments = {
  development: {
    environment: "development",
    baseUrl: "http://localhost:8080",
    stripe: {
      key: "pk_test_J9YVbhMHSeF5kUJE6L7gDMtJ00KvaBQYX6",
      clientId: "ca_GlLVgVHUDYjWzm6BSzWPHbHkwf2ZkWzx"
    },
    firebase: {
      apiKey: "AIzaSyCWncuIHM6TsQaGhsQvAI9W28c0F5i8be4",
      authDomain: "smartbooks365-a9889.firebaseapp.com",
      databaseURL: "https://smartbooks365-a9889.firebaseio.com",
      cloudFunctionsURL:
        "https://us-central1-smartbooks365-a9889.cloudfunctions.net/api",
      projectId: "smartbooks365-a9889",
      storageBucket: "smartbooks365-a9889.appspot.com",
      messagingSenderId: "575977731656",
      appId: "1:575977731656:web:1725f6bfd834c2c4858a7d"
    }
  },
  production: {
    environment: "production",
    baseUrl: "https://smartbooks365.com",
    stripe: {
      key: "pk_live_GSsco0xSrPwSEcP5Z6SmVr3S005ap8Dfnc",
      clientId: "ca_GlLV2KN41TKOmAXfHhhvOsH4mFzwzXyz"
    },
    firebase: {
      apiKey: "AIzaSyDyEV1xhxoP9kWhrk201rs3SkBi0IbFWxM",
      authDomain: "smartbooks365-production.firebaseapp.com",
      databaseURL: "https://smartbooks365-production.firebaseio.com",
      cloudFunctionsURL:
        "https://us-central1-smartbooks365-production.cloudfunctions.net/api",
      projectId: "smartbooks365-production",
      storageBucket: "smartbooks365-production.appspot.com",
      messagingSenderId: "950300975559",
      appId: "1:950300975559:web:ab1674df44329529b1b9e2",
      measurementId: "G-PFH9XQPB9L"
    }
  }
};

export default environments[process.env.NODE_ENV];
